import React from 'react';
import { FileDown } from 'lucide-react';

import { ActionRow, ChipRow, PageHeader, PhonePage } from '@/components/phone/primitives';

/**
 * The reports rail, as a row of chips.
 *
 * On a laptop the rail down the side lists every report under its group; a
 * phone has no side. The same list runs across the top as chips that scroll,
 * and the report reads below at full width — the report bodies draw their own
 * tables as cards, so nothing here knows what a report contains.
 */
export default function PhoneReports({ reports, active, onSelect, showMoney, onExport, children }) {
  const report = reports.find((r) => r.key === active) || reports[0];
  return (
    <PhonePage testID="reports-phone">
      <PageHeader title="Reports" subtitle={report?.label} />
      <div className="px-5">
        <ChipRow
          chips={reports.map((r) => ({ key: r.key, label: r.label }))}
          active={report?.key}
          onSelect={onSelect}
          testIDPrefix="report-chip"
        />
        {showMoney && (
          <ActionRow
            testID="export-row"
            actions={[
              { key: 'orders', label: 'Export orders', icon: FileDown, onClick: () => onExport('orders'), testID: 'export-orders-btn' },
              { key: 'outstanding', label: 'Export outstanding', icon: FileDown, onClick: () => onExport('outstanding'), testID: 'export-outstanding-btn' },
            ]}
          />
        )}
      </div>
      <div className="px-5 pb-8 pt-2" role="tabpanel" id="report-panel" aria-label={report?.label}>
        {children}
      </div>
    </PhonePage>
  );
}
